module.exports = __webpack_public_path__ + "static/media/unionpay.8063456b.png";